import { useState } from 'react'

import { downloadSourceFile } from 'utils/sourceFiles'

/**
 * Hook for downloading source file links with loading and error state.
 *
 * @returns download function together with loading and error flags
 */
export const useSourceFileDownload = (onError?: () => void) => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)

  const download = (link: string) => {
    if (loading) {
      return
    }

    setError(false)
    setLoading(true)

    downloadSourceFile(link)
      .catch(() => {
        setError(true)
        onError?.()
      })
      .finally(() => setLoading(false))
  }

  return { download, loading, error }
}
